import { render, staticRenderFns } from "./bshyj.vue?vue&type=template&id=2175d422&scoped=true"
import script from "./bshyj.vue?vue&type=script&lang=js"
export * from "./bshyj.vue?vue&type=script&lang=js"
import style0 from "./bshyj.vue?vue&type=style&index=0&id=2175d422&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175d422",
  null
  
)

export default component.exports